module.exports = __webpack_public_path__ + "b7272ecc9ffe59a670b9d0a2f2a96f0e.svg";